<template>
  <v-container fluid
    fill-height class="pa-0">
    <v-navigation-drawer
      fixed
      absolute
      app
      v-model="drawer"
      dark
      class="primary lighten-1"
    >
      <v-list dense>
        <v-list-tile class="pt-5 pb-3" color="white">
          <v-layout column>
            <img
              :src="require('@/assets/logomarcadark.png')" style="width: 40px"
            />
            <span class="caption">{{user ? user.email : ''}}</span>
          </v-layout>
          <v-spacer/>
          <v-btn flat icon @click="sair">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-list-tile>
        <v-divider></v-divider>
        <template v-for="item in items">
          <v-layout
            row
            v-if="item.heading"
            align-center
            :key="item.heading"
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" ripple @click="$router.push(item.route)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      fixed
      absolute
      app
      v-model="notificacoes"
      v-if="notificacoes"
      dark
      class="primary lighten-1"
      right
    >
      <v-list two-line v-if="!loading">
        <v-subheader class="mb-4">
          Notificações
        </v-subheader>
        <template v-for="(notificacao, index) in lista_notificacoes">
          <v-divider
              v-if="index > 0"
              :key="`${index}d`"
              inset
            ></v-divider>
            <v-menu
              offset-x
              :key="`${index}n`"
              left
              transition="slide-x-reverse-transition"
            >
              <template v-slot:activator="{ on }">
                <v-list-tile
                    v-on="on"
                    :key="`${index}l`"
                    style="height: 8em;"
                >
                  <v-list-tile-avatar
                    style="
                      height: 100%;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <v-icon size="2.5em">circle_notifications</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content
                    style="
                      height: 8em;
                      margin-top: 1em;
                    "
                  >
                    <v-list-tile-title
                      v-html="notificacao.title"
                      style="
                        font-size: 1.1em;
                      "
                      class="mb-1"
                    ></v-list-tile-title>
                    <v-flex
                      v-html="notificacao.subtitle"
                      style="
                        font-size: 0.9em;
                      "
                    ></v-flex>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list>
                <template v-for="(action, index) in notificacao.actions">
                  <v-list-tile ripple @click="action.function(notificacao)" :key="index">
                    <v-list-tile-content>
                      <v-list-tile-title
                        :class="`text-xs-center body-2 ${action.color}--text`"
                        >{{action.text}}</v-list-tile-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon :color="action.color">{{action.icon}}</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
        </template>
      </v-list>
      <v-layout align-center justify-center column v-else>
        <v-subheader class="mb-4">
          Notificações
        </v-subheader>
        <v-flex xs4 class="mt-4">
          <v-progress-circular
          indeterminate
          :size="50"
          color="white"
        ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <v-toolbar
      color="#eee"
      app
      fixed
      class="elevation-0"
    >
      <v-badge color="primary" overlap v-if="user">
        <v-icon
          slot="badge"
          dark
          small
        >menu</v-icon>
        <v-btn flat icon dark class="ma-0" @click.stop="drawer = !drawer" :disabled="!autenticacaoRealizada">
          <v-avatar
            color="grey"
            size="30">
            <img v-if="user.image" :src="user.image" alt="trevor">
            <v-icon dark v-else>face</v-icon>
          </v-avatar>
        </v-btn>
      </v-badge>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn flat icon dark class="red" slot="activator" @click="authenticationDialog = true" v-if="!smartLock" :disabled="!autenticacaoRealizada">
          <v-icon size="19">lock</v-icon>
        </v-btn>
        <v-btn flat round dark class="green" slot="activator" @click="restoreTime" v-else :disabled="!autenticacaoRealizada">
          <v-spacer></v-spacer>
          {{formatedTimer}}
          <v-spacer></v-spacer>
          <v-icon size="19" class="pl-2">lock_open</v-icon>
        </v-btn>
        Smart Lock
      </v-tooltip>
       <v-tooltip bottom>
          <v-badge
          slot="activator"
          :content="lista_notificacoes.length"
          :value="lista_notificacoes.length"
          color="white"
          left
        >
          <v-btn icon color="primary" @click="notificacoes = !notificacoes" :disabled="!smartLock">
            <v-icon>notifications</v-icon>
          </v-btn>
          </v-badge>
          Notificações
       </v-tooltip>
    </v-toolbar>
    <v-content style="height: 100%">
      <v-alert
        v-if="updateVersion || hasNewVersion"
        :value="true"
        type="error"
        class="pa-1"
        icon="update"
        >
          <v-layout>
            <div class="mt-2">Uma nova atualização está disponível</div>
            <v-spacer></v-spacer>
            <v-btn small @click="atualizar">Atualizar</v-btn>
          </v-layout>
        </v-alert>
      <router-view></router-view>
    </v-content>
    <v-dialog v-model="authenticationDialog" width="500" lazy>
      <autenticar-smart-lock @fechar="authenticationDialog = false" @autenticado="authenticationDialog = false"></autenticar-smart-lock>
    </v-dialog>
    <v-dialog v-model="dialogAtualizacaoPag" width="500" lazy>
      <dialog-atualizacao-pagina  @fechar="dialogAtualizacaoPag = false"/>
    </v-dialog>
    <v-dialog v-if="dialogInfluenciador" v-model="dialogInfluenciador" width="600" :fullscreen="$vuetify.breakpoint.xs">
      <cad-influenciador :cliente="selectedObject" @fechar="dialogInfluenciador = false" @carregarNotificacoes="carregarNotificacoes"/>
    </v-dialog>
    <v-dialog v-if="dialogRetirada" v-model="dialogRetirada" width="500" :fullscreen="$vuetify.breakpoint.xs">
      <solicitacao-pagamento
        :solicitacao="selectedObject"
        @fechar="dialogRetirada = false"
        @carregarNotificacoes="carregarNotificacoes"
        @success="showSuccess"
      />
    </v-dialog>
    <v-dialog v-model="dialogBloqueio" v-if="dialogBloqueio" width="400">
      <bloqueio-empresa :bloqueio="selectedObject" @fechar="dialogBloqueio = false" @carregarNotificacoes="carregarNotificacoes"/>
    </v-dialog>
    <v-dialog v-model="dialogAtivacao" v-if="dialogAtivacao" width="400">
      <aceitar-ativacao scrollable :object="selectedObject" @fechar="dialogAtivacao = false" @carregarNotificacoes="carregarNotificacoes"/>
    </v-dialog>
    <v-dialog v-model="dialogCreditoCarteira" v-if="dialogCreditoCarteira" width="600" scrollable>
      <dialog-adicao-de-credito
        :compraCredito="selectedObject"
        @fechar="dialogCreditoCarteira = false"
        @carregarNotificacoes="carregarNotificacoes"
        @success="showSuccess"
      />
    </v-dialog>
    <v-dialog width="50em" v-model="dialogPropostaApetrus" v-if="dialogPropostaApetrus" scrollable>
      <dialog-detalhes-proposta @error="showError" @success="showSuccess" :proposta="selectedObject" @fechar="dialogPropostaApetrus = false" @carregar="carregarNotificacoes"/>
    </v-dialog>
    <v-dialog width="50em" v-model="dialogRecebimento" v-if="dialogRecebimento" scrollable>
      <dialog-recebimento-carteira @error="showError" @success="showSuccess" :posto="selectedObject" @fechar="dialogRecebimento = false" @carregar="carregarNotificacoes"/>
    </v-dialog>
    <v-dialog width="40em" v-model="dialogParceiria" v-if="dialogParceiria" scrollable>
      <solicitacao-parceiria @error="showError" @success="showSuccess" :empresa="selectedObject" @fechar="dialogParceiria = false" @carregar="carregarNotificacoes"/>
    </v-dialog>
    <v-dialog v-model="dialogAssinatura" v-if="dialogAssinatura"  width="50em" scrollable>
      <programa-assinatura
        @error="showError"
        @success="showSuccess"
        @fechar="dialogAssinatura = false, selectedObject = null"
        @carregar="carregarNotificacoes"
        :objeto="selectedObject"
      />
    </v-dialog>

    <v-dialog v-model="dialogResponderSolicitacao" v-if="dialogResponderSolicitacao"  width="50em" scrollable>
      <responder-solicitacao
        @error="showError"
        @success="showSuccess"
        @fechar="dialogResponderSolicitacao = false, selectedObject = null"
        @carregar="carregarNotificacoes"
        :solicitacao="selectedObject"
      />
    </v-dialog>

    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
        <v-btn
          flat
          @click="snackbar.active = false"
        >
          Fechar
        </v-btn>
      </v-snackbar>
  </v-container>
</template>

<script>

import AutenticarSmartLock from '@/components/dialogs/AutenticarSmartLock'
import DialogAtualizacaoPagina from '@/components/dialogs/DialogAtualizacaoPagina'
import SolicitacaoPagamento from '@/components/dialogs/SolicitacaoPagamento'
import BloqueioEmpresa from '@/components/dialogs/BloqueioEmpresa'
import AceitarAtivacao from '@/components/dialogs/AceitarAtivacao'
import CadInfluenciador from '@/components/cadastros/CadInfluenciador'
import DialogAdicaoDeCredito from '@/components/dialogs/AdicaoDeCredito'
import DialogDetalhesProposta from '@/components/dialogs/DetalhesProposta'
import DialogRecebimentoCarteira from '@/components/dialogs/RecebimentoCarteira'
import SolicitacaoParceiria from '@/components/dialogs/SolicitacaoParceiria'
import ProgramaAssinatura from '@/components/dialogs/ProgramaAssinatura'
import ResponderSolicitacao from '@/components/dialogs/ResponderSolicitacao'
import moment from 'moment'
import { version, name } from '../../../package.json'

export default {
  name: 'App',
  components: {
    AutenticarSmartLock,
    DialogAtualizacaoPagina,
    CadInfluenciador,
    SolicitacaoPagamento,
    BloqueioEmpresa,
    AceitarAtivacao,
    DialogAdicaoDeCredito,
    DialogDetalhesProposta,
    DialogRecebimentoCarteira,
    SolicitacaoParceiria,
    ProgramaAssinatura,
    ResponderSolicitacao
  },
  data: () => ({
    drawer: false,
    dialogAtualizacaoPag: false,
    verificationScreen: false,
    authenticationDialog: false,
    dialogUpdate: false,
    dialogBloqueio: false,
    dialogCreditoCarteira: false,
    notificacoes: false,
    lista_notificacoes: [],
    dialogRetirada: false,
    dialogInfluenciador: false,
    selectedObject: null,
    dialogAtivacao: false,
    dialogPropostaApetrus: false,
    dialogRecebimento: false,
    dialogParceiria: false,
    dialogAssinatura: false,
    dialogResponderSolicitacao: false,
    items: [
      { icon: 'account_balance_wallet', text: 'Carteira Apetrus', route: '/carteiravirtual' },
      { icon: 'volume_up', text: 'Anúncios', route: '/anuncios' },
      { icon: 'local_gas_station', text: 'Postos', route: '/home' },
      { icon: 'ac_unit', text: 'Redes', route: '/redes' },
      { icon: 'business', text: 'Empresas', route: '/empresas' },
      { icon: 'apartment', text: 'Rede Empresas', route: '/redeempresas' },
      { icon: 'thumbs_up_down', text: 'Convênios', route: '/convenios' },
      { icon: 'autorenew', text: 'Faturamentos', route: '/faturamentos' },
      { icon: 'account_circle', text: 'Clientes', route: '/clientes' },
      { icon: 'work', text: 'Negociações', route: '/negociacoes' },
      { icon: 'insert_drive_file', text: 'Relatórios', route: '/relatorio' },
      { icon: 'people', text: 'Usuários Apetrus', route: '/usuarios' },
      { icon: 'airport_shuttle', text: 'Veículos', route: '/veiculos' },
      { icon: 'class', text: 'Bandeiras', route: '/bandeiras' },
      { icon: 'category', text: 'Categorias', route: '/categorias' },
      { icon: 'android', text: 'Automações', route: '/automacao' },
      { icon: 'smart_toy', text: 'Relatório IA', route: '/relatorioia' },
      { icon: 'credit_card', text: 'Formas de Pagamento', route: '/formaspag' },
      { icon: 'credit_card', text: 'Tipos de Pagamento', route: '/tipospag' },
      { icon: 'currency_exchange', text: 'Meio de recebimento', route: '/meiosderecebimento' },
      { icon: 'message', text: 'Notificar Usuário', route: '/notificacoes' },
      { icon: 'chat_bubble', text: 'Faq', route: '/faq' },
      { icon: 'cached', text: 'Versionamento', route: '/versionamento' },
      { icon: 'assignment', text: 'Termos de Uso e Políticas', route: '/termospoliticas' },
      { icon: 'settings', text: 'Configurações da Conta', route: '/configuracoes' }
    ],
    snackbar: {
      active: false,
      color: '',
      multiLine: true,
      timeout: 4000,
      vertical: true,
      text: ''
    }
  }),
  props: {
    source: String
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    pendingUsers () {
      return this.$store.getters.pendingUsers
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    pessoa () {
      return this.$store.getters.pessoa
    },
    formatedTimer () {
      let duration = moment.duration(this.timer, 'seconds')
      let tempHours = duration.hours()
      let tempMinutes = duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes()
      let tempSeconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds()
      return `${tempHours}:${tempMinutes}:${tempSeconds}`
    },
    timer () {
      return this.$store.getters.timer
    },
    hasNewVersion () {
      return this.$store.getters.hasNewVersion
    },
    versaoApp () {
      return this.$store.getters.versaoApp
    },
    updateVersion () {
      return this.$store.getters.versaoApp !== version
    },
    compras_estorno () {
      return this.$store.getters.compras_estorno
    },
    autenticacaoRealizada () {
      if (localStorage.getItem(`${this.user ? this.user.id : undefined}/dispositivoAutenticado`) || (this.pessoa && !this.pessoa.autenticacao)) {
        return true
      }
      return false
    }
  },
  watch: {
    autenticacaoRealizada: {
      handler (val) {
        if (!val) this.$router.push('/')
      },
      deep: true
    },
    headers (val) {
      if (val) {
        this.$store.dispatch('carregarCombustiveis')
        this.$store.dispatch('checkPedingVerifications')
        this.carregarNotificacoes()
      }
    },
    smartLock (val) {
      if (val && this.lista_notificacoes.length > 0) {
        alert('Você tem novas notificações')
      }
    },
    notificacoes (val) {
      if (val) {
        this.carregarNotificacoes()
      }
    }
  },
  created () {
    this.$store.dispatch('verificarAtualizacao', {
      name: name,
      version: version
    })
    window.addEventListener('keydown', (e) => {
      if (this.smartLock && ((e.ctrlKey && e.keyCode === 82) || e.keyCode === 116 || (e.shiftKey && e.keyCode === 82))) {
        e.preventDefault()
        this.dialogAtualizacaoPag = true
      }
    })
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('carregarCombustiveis')
      this.$store.dispatch('checkPedingVerifications')
      this.carregarNotificacoes()
      if (this.lista_notificacoes.length > 0) {
        alert('Você tem novas notificações')
      }
    }
  },
  methods: {
    saveEvent () {
      this.$store.dispatch('createEvent', this.event)
    },
    sair () {
      this.$store.dispatch('signUserOut')
    },
    restoreTime () {
      this.$store.dispatch('restoreTimer')
    },
    showSuccess (info) {
      this.snackbar.color = 'primary'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    ConfirmarVisualizacao (notificacao) {
      switch (notificacao.type) {
        case 'convenio':
          notificacao.object['notificado'] = true
          this.$store.dispatch('editarConvenios', notificacao.object).then(value => {
            if (value) {
              this.carregarNotificacoes()
            }
          })
          break
        default:
          this.showError('Você não pode realizar essa função.')
      }
    },
    visualizarNotificacao (notificacao) {
      this.selectedObject = notificacao.object
      switch (notificacao.type) {
        case 'influenciador':
          this.selectedObject = this.selectedObject.cliente
          this.dialogInfluenciador = true
          break
        case 'CompraCrédito':
          this.dialogCreditoCarteira = true
          break
        case 'retirada':
          this.dialogRetirada = true
          break
        case 'bloqueio':
          this.dialogBloqueio = true
          break
        case 'novoContrato':
          this.dialogAtivacao = true
          break
        case 'propostaApetrus':
          this.dialogPropostaApetrus = true
          break
        case 'posto_carteira':
          this.dialogRecebimento = true
          break
        case 'empresa_parceira':
          this.dialogParceiria = true
          break
        case 'programa_assinatura':
          this.dialogAssinatura = true
          break
        case 'mudanca_tipo':
          this.dialogResponderSolicitacao = true
          break
        case 'convenio':
          this.dialogResponderSolicitacao = true
          break
        default:
          this.showError('Você não pode realizar essa função.')
      }
    },
    carregarNotificacoes () {
      this.lista_notificacoes = []
      this.$store.dispatch('getConvenios', { filtros: { notificado: false, ativo: true } }).then(solicitacoes => {
        solicitacoes.map((solicitacao) => {
          this.lista_notificacoes.push({
            title: 'Novo Convênio Adicionado',
            subtitle: `<p>CONVÊNIO: ${solicitacao.nome_convenio}<br>CÓDIGO: ${solicitacao.codigo} </p>`,
            type: 'convenio',
            object: solicitacao,
            actions: [
              { text: 'Remover Notificação', color: 'primary', icon: 'close', function: this.ConfirmarVisualizacao }
            ]
          })
        })
      })

      this.$store.dispatch('pegarInfluenciador', {}).then(solicitacoes => {
        solicitacoes.map((solicitacao) => {
          this.lista_notificacoes.push({
            title: 'Solicitação para influenciar',
            subtitle: `<p>Por: ${solicitacao.cliente.pessoa.nome} ${solicitacao.cliente.pessoa.sobrenome ? solicitacao.cliente.pessoa.sobrenome : ''}</p>`,
            type: 'influenciador',
            object: solicitacao,
            actions: [
              { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
            ]
          })
        })
      })

      this.$store.dispatch('solicitacoesRetirada').then(solicitacoes => {
        solicitacoes.map((solicitacao) => {
          if (solicitacao.cliente) {
            this.lista_notificacoes.push({
              title: 'Solicitação de retirada',
              subtitle: `<p>Por: ${solicitacao.cliente.pessoa.nome} ${solicitacao.cliente.pessoa.sobrenome ? solicitacao.cliente.pessoa.sobrenome : ''}</p>`,
              type: 'retirada',
              object: solicitacao,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
          } else if (solicitacao.posto) {
            this.lista_notificacoes.push({
              title: 'Solicitação de retirada',
              subtitle: `<p>Por: ${solicitacao.posto.nome_fantasia}</p>`,
              type: 'retirada',
              object: solicitacao,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
          })
          } else if (solicitacao.empresa) {
            this.lista_notificacoes.push({
              title: 'Solicitação de retirada',
              subtitle: `<p>Por: ${solicitacao.empresa.nome_fantasia}</p>`,
              type: 'retirada',
              object: solicitacao,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
          }
        })
      })

      this.$store.dispatch('pegarBloqueios').then(bloqueios => {
        bloqueios.map((bloqueio) => {
          this.lista_notificacoes.push({
            title: 'Bloqueio',
            subtitle: `<p>A empresa ${bloqueio.empresa.nome_fantasia} foi bloquada ${bloqueio.posto ? `pelo posto ${bloqueio.posto.nome_fantasia.replace('Posto', '')}` : `pela rede ${bloqueio.rede.nome.replace('Rede', '')}`}</p>`,
            type: 'bloqueio',
            object: bloqueio,
            actions: [
              { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
            ]
          })
        })
      })

      this.$store.dispatch('pegarNovosContratos').then(contratos => {
        const postos = contratos.postos
        const empresas = contratos.empresas

        postos.map((posto) => {
          this.lista_notificacoes.push({
            title: 'Novo Posto',
            subtitle: `<p>O Posto ${posto.nome_fantasia.replace('Posto', '')} entrou dia ${posto.created_at.split('T')[0].split('-').reverse().join('/')}</p>`,
            type: 'novoContrato',
            object: posto,
            actions: [
              { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
            ]
          })
        })

        empresas.map((empresa) => {
          this.lista_notificacoes.push({
            title: 'Nova Empresa',
            subtitle: `<p>A empresa ${empresa.nome_fantasia} entrou dia ${empresa.created_at.split('T')[0].split('-').reverse().join('/')}</p>`,
            type: 'novoContrato',
            object: empresa,
            actions: [
              { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
            ]
          })
        })
      })
      this.$store.dispatch('adicaoDeCredito', {
        method: 'GET'
      }).then(json => {
        json.map((compraCredito) => {
          this.lista_notificacoes.push({
            title: `Compra de crédito`,
            subtitle: `<p>De ${
              compraCredito.individuo.administrador ? `empresa ${
                compraCredito.individuo.nome_fantasia
              }` : compraCredito.individuo.representante ? `posto  ${
                compraCredito.individuo.nome_fantasia.replace('Posto', '')
              }` : `${
                compraCredito.individuo.nome
              } ${compraCredito.individuo.sobrenome}`
            }</p>`,
            type: 'CompraCrédito',
            object: compraCredito,
            actions: [
              { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
            ]
          })
        })
      })
      this.$store.dispatch('propostasApetrus', { method: 'GET', filtro: { status: null } }).then(json => {
          json.map((proposta) => {
            this.lista_notificacoes.push({
              title: `Proposta Apetrus`,
              subtitle: `<p>De empresa ${
                proposta.empresa.nome_fantasia }
              </p>`,
              type: 'propostaApetrus',
              object: proposta,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
          })
        })
      this.$store.dispatch('notificacoesAdmin', { method: 'GET' }).then(json => {
        json.posto_carteira.map((p) => {
          this.lista_notificacoes.push({
              title: `Recebimento pela carteira`,
              subtitle: `<p>O posto ${
                p.nome_fantasia.replace('Posto', '') } deseja receber pela carteira.
              </p>`,
              type: 'posto_carteira',
              object: p,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao },
                { text: 'ACEITAR', color: 'success', icon: 'done', function: this.aceitarContrato },
                { text: 'REJEITAR', color: 'error', icon: 'close', function: this.rejeitarContrato }
              ]
            })
        })
      })
      this.$store.dispatch('procurarEmpresasPorAdm', {
        filtros: {
          aceita__isnull: true,
          is_empresa_parceira: false
        }
      }).then(json => {
        json.map((e) => {
          this.lista_notificacoes.push({
              title: `Solicitação de parceiria`,
              subtitle: `<p>A empresa ${
                e.nome_fantasia } deseja ser parceira.
              </p>`,
              type: 'empresa_parceira',
              object: e,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
        })
      })
      this.$store.dispatch('pegarTodosPostos', {
        tem_programa_assinatura__isnull: true
      }).then(json => {
        json.map((p) => {
          this.lista_notificacoes.push({
              title: `Programa de assinatura`,
              subtitle: `<p>O posto ${
                p.nome_fantasia } deseja participar do programa de assinatura.
              </p>`,
              type: 'programa_assinatura',
              object: p,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
        })
      })
      this.$store.dispatch('pegarTodasRedes', {
        tem_programa_assinatura__isnull: true
      }).then(json => {
        json.map((r) => {
          this.lista_notificacoes.push({
              title: `Programa de assinatura`,
              subtitle: `<p>A rede ${
                r.nome } deseja participar do programa de assinatura.
              </p>`,
              type: 'programa_assinatura',
              object: r,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
        })
      })
      this.$store.dispatch('solicitacoes', {
        status__isnull: true
      }).then(json => {
        json.map((r) => {
          this.lista_notificacoes.push({
              title: r.tipo,
              subtitle: r.descricao,
              type: r.referencia,
              object: r,
              actions: [
                { text: 'VISUALIZAR', color: 'primary', icon: 'remove_red_eye', function: this.visualizarNotificacao }
              ]
            })
        })
      })
    },
    estornar (notificacao) {
      const cartao = notificacao.object
      this.$store.dispatch('estornarDinheiro', cartao.id_cartao).then(value => {
          if (value) {
            this.showSuccess('Estorno realizado com sucesso')
            this.carregarNotificacoes()
          }
      })
    },
    cancelarEstorno (notificacao) {
      const cartao = notificacao.object
      this.$store.dispatch('cancelarEstorno', cartao.id_cartao).then(value => {
          if (value) {
            this.showSuccess('Cancelamento realizado com sucesso')
            this.carregarNotificacoes()
          }
      })
    },
    aceitarContrato (notificacao) {
      this.$store.dispatch('notificacoesAdmin', {
        method: 'PUT',
        tipo: 'posto_carteira',
        cnpj: notificacao.object.cnpj,
        resposta: true
      }).then(() => {
        this.carregarNotificacoes()
      }).catch(() => {
        this.showError('Não foi possível aceitar solicitação.')
      })
    },
    rejeitarContrato (notificacao) {
      this.$store.dispatch('notificacoesAdmin', {
        method: 'PUT',
        tipo: 'posto_carteira',
        cnpj: notificacao.object.cnpj,
        resposta: false
      }).then(() => {
        this.showSuccess('Solicitação rejeitada com sucesso.')
        this.carregarNotificacoes()
      }).catch(() => {
        this.showError('Não foi possível rejeitar solicitação.')
      })
    },
    atualizar () {
      this.$store.dispatch('atualizarVersaoApp', {
        name: name,
        version: version
      })
      window.location.reload(true)
    }
  }
}
</script>

<style>
.v-list--two-line .v-list__tile {
    height: 8em;
    margin-top: 1em;
}
</style>
